import ParcelaDto from '../dto/ParcelaDto';

export default class ParcelaResource {
  dataVencimento: Date;
  valor: number;
  paga: boolean;
  vencida: boolean;
  numeroParcela: number;

  constructor(resource: ParcelaDto) {
    this.dataVencimento = new Date(resource.dataVencimento);
    this.valor = resource.valor;
    this.paga = resource.paga;
    this.vencida = resource.vencida;
    this.numeroParcela = resource.numeroParcela;
  }
}
